export const environment = {
  production: false,
  ambiente: 'PROD',

  api: 'https://minhasnotificacoesapi.uninter.com/',
  webUrl: 'https://minhasnotificacoes.uninter.com/',

  apiAccount: 'https://accountapi.uninter.com/',
  webAccount: 'https://account.uninter.com/'
  };